import { render, staticRenderFns } from "./AutomaticWashCar.vue?vue&type=template&id=37fda46c"
import script from "./AutomaticWashCar.vue?vue&type=script&lang=js"
export * from "./AutomaticWashCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports